<div *ngIf="showLoader" class="dnbi-loader-container">
  <div class="dnbi-loader-gif"></div>
  <img src="../../../../../../assets/images/common/dnb-loading.gif" alt="loading indicator" />
</div>
<div *ngIf="!serverError" class="d-flex flex-column">
  <div class="banner-container">
    <div class="frequent-title-color text-lg banner-font banner-margin text-center">
      Digital Service Center
    </div>
  </div>

  <app-help-topics *ngIf="userAccess !== 'no-access'" [featureList]="featureList"></app-help-topics>

  <div class="create-user-container pt-0 pb-4" id="create-user">
    <div *ngIf="userAccess !== 'no-access'" class="route-title back-navigation col-xs-12 col-sm-4 col-md-8 text-3xl pl-0">
      <span class="back-home" (click)="navigateBack()" routerLinkActive="router-link-active">
        <img alt="Left Arrow" class="left-arrow-image" src="assets/images/feature/arrow_back.png" />
        Home
      </span>

    </div>
    <div *ngIf="userAccess == 'no-access' && !userCreated" class="col-12 col-md-8 no-access-container">
      <div class="no-access-msg">
      <img
      class="mb-1"
      height="28"
      width="28"
      src="../assets/images/feature/error_large.png"
      alt="form error"
    />
  <h4 class="title-color mb-2" style="font-size: 20px;color:#161919;margin-top: 5px;">
    Sorry, You are currently not registered to login to the US Digital Service Center.
  </h4>
</div>
  <h5 class="title-color mb-2" style="font-size: 16px;color:#161919;">If you are a current D&B US Customer, please register below, otherwise, please <span class="link" (click)="navigateUrlToHome()">click here</span> to visit our home page.</h5>
  </div>
  
    <div class="col-12 col-md-8 content-border mt-3 mb-3 pt-3 pb-3 card-padding">
      <app-create-sso-user [createUser]="createUser" (successSectionContent)="successSectionContentChange($event)"></app-create-sso-user>
    </div>

  </div>

  <!-- <app-helpful-links [channelMapDataHelfulLink]="helpfulLinksList"></app-helpful-links> -->
</div>